var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/layout/layout.tsx";
import classNames from 'classnames';
import React from 'react';
/** Layout container, to hold Sidebar, Main, and Aside. */
const Layout = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "relative",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "max-w-3xl mx-auto sm:px-6 md:max-w-7xl md:px-8 md:flex md:gap-8 h-screen overflow-y-auto grow",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 13,
    columnNumber: 5
  }
}, children));

/** Left sidebar container in the UI. */
const Sidebar = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "hidden lg:block lg:col-span-3 md:min-w-[300px] md:max-w-[300px] sm:py-4",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 21,
    columnNumber: 3
  }
}, children);

/** Center column container in the UI. */
const Main = ({
  children,
  className
}) =>
/*#__PURE__*/
// pb is here to let space for the bottom bar
React.createElement("main", {
  className: classNames('md:w-full md:min-w-0 md:overflow-y-auto animate-fadein grow flex flex-col sm:pt-4 pb-[110px] lg:pb-0 ', className),
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 29,
    columnNumber: 3
  }
}, children);

/** Right sidebar container in the UI. */
const Aside = ({
  children,
  className
}) => /*#__PURE__*/React.createElement("aside", {
  className: `hidden lg:flex flex-col lg:col-span-3 md:min-w-[200px] md:max-w-[200px] grow animate-fadein sm:py-4 ${className || ''}`,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 36,
    columnNumber: 3
  }
}, children);
Layout.Sidebar = Sidebar;
Layout.Main = Main;
Layout.Aside = Aside;
export default Layout;